import { Routes, RouterModule }  from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';
// noinspection TypeScriptValidateTypes

// export function loadChildren(path) { return System.import(path); };

export const routes: Routes = [
    {
        path: 'mastercard/en',
        loadChildren: 'app/pages/static/mastercard/en/mastercard-en.module#MastercardEnModule'
    },
    {
        path: 'mastercard/hr',
        loadChildren: 'app/pages/static/mastercard/hr/mastercard-hr.module#MastercardHrModule'
    },
    {
        path: 'visa/en',
        loadChildren: 'app/pages/static/visa/en/visa-en.module#VisaEnModule'
    },
    {
        path: 'visa/hr',
        loadChildren: 'app/pages/static/visa/hr/visa-hr.module#VisaHrModule'
    },
    {
        path: 'payment',
        loadChildren: 'app/pages/static/payment/payment.module#PaymentModule'
    },
    {
        path: 'login',
        loadChildren: 'app/pages/login/login.module#LoginModule'
    },
    {
        path: 'forgot-password',
        loadChildren: 'app/pages/passwords/forgot-password/forgot-password.module#ForgotPasswordModule',
    },
    {   // Registration from backoffice
        path: 'set_password/:reg_token',
        loadChildren: 'app/pages/register-confirm/member/member.module#MemberRegistrationConfirmModule',
    },
    {   // Registration from mobile app
        path: 'registration_confirm/:reg_token',
        loadChildren: 'app/pages/register-confirm/user/user.module#UserRegistrationConfirmModule',
    },
    {   
        path: 'users/password/reset/:reg_token',
        loadChildren: 'app/pages/passwords/set-password/set-password.module#SetPasswordModule',
    },
    {
        path: 'pages',
        component: Pages,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
            { path: 'change-password', loadChildren: './passwords/change-password/change-password.module#ChangePasswordModule' },
            { path: 'users', loadChildren: './users/users.module#UsersModule' },
            { path: 'notifications', loadChildren: './notifications/notifications.module#NotificationsModule' },
            { path: 'transactions', loadChildren: './transactions/transactions.module#TransactionsModule' },
            { path: 'comments', loadChildren: './comments/comments.module#CommentsModule' },
        ]
    }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/pages/pages.routing.ts